import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ScrollTop from './components/ScrollTop';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import PrincipalsWelcome from './pages/PrincipalsWelcome';
import InternationalStudent from './pages/InternationalStudent';
import Courses from './pages/Courses';
import Calendar from './pages/Calendar';
import ContactUs from './pages/ContactUs';
import CourseFees from './pages/CourseFees';
import EDSQ from './pages/EDSQ';
import BCSITQ from './pages/BCSITQ';
import MathsFunctionalEntry from './pages/MathsFunctionalEntry';
import EnglishFunctionalEntry from './pages/EnglishFunctionalEntry';
import FunctionalEnglishLevel2 from './pages/FunctionalEnglishLevel2';
import FunctionalMathsLevel2 from './pages/FunctionalMathsLevel2';
import Policies from './pages/Policies';
import ApprenticeshipsIntro from './pages/ApprenticeshipsIntro';
import InfoManagerLevel4 from './pages/InfoManagerLevel4';
import AdultCareWorkerLevel2 from './pages/AdultCareWorkerLevel2';
import HairProfessionalLevel2 from './pages/HairProfessionalLevel2';
import CreativeHairProfessionalLevel3 from './pages/CreativeHairProfessionalLevel3';
import LeadAdultCareWorkerLevel3 from './pages/LeadAdultCareWorkerLevel3';
import LeaderAdultCareLevel5 from './pages/LeaderAdultCareLevel5';
import LeadPractitionerAdultCareLevel4 from './pages/LeadPractitionerAdultCareLevel4';
import CommisChefLevel2 from './pages/CommisChefLevel2';
import ProductionChefLevel2 from './pages/ProductionChefLevel2';
import BusinessAdministrationLevel3 from './pages/BusinessAdministrationLevel3';
import UKEUStudents from './pages/UKEUStudents';
import DataProtectionPolicy from './pages/DataProtectionPolicy';
import ComplaintPolicy from './pages/ComplaintPolicy';
import EqualityDiversityPolicy from './pages/EqualityDiversityPolicy';
import AssessmentAppealsPolicy from './pages/AssessmentAppealsPolicy';
import HealthSafetyPolicy from './pages/HealthSafetyPolicy';
import ConflictInterestPolicy from './pages/ConflictInterestPolicy';
import CollegeIAGPolicy from './pages/CollegeIAGPolicy';
import MalpracticePlagiarismPolicy from './pages/MalpracticePlagiarismPolicy';
import SaferRecruitmentPolicy from './pages/SaferRecruitmentPolicy';
import SustainabilityPolicy from './pages/SustainabilityPolicy';
import ModernSlaveryPolicy from './pages/ModernSlaveryPolicy';
import SafeguardingPolicy from './pages/SafeguardingPolicy';
import PreventPolicy from './pages/PreventPolicy';
import WhistleblowingPolicy from './pages/WhistleblowingPolicy';

function GAListener() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') {
      return;
    }

    console.log('GA page_view', location.pathname + location.search);
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title
    });
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll)
    if (window.AOS) {
      window.AOS.init({
        duration: 600,
        easing: 'ease-in-out',
        once: true,
        mirror: false
      });
    }

    // Initialize GLightbox
    if (window.GLightbox) {
      window.GLightbox({
        selector: '.glightbox'
      });
    }

    // Remove preloader
    const preloader = document.getElementById('preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.display = 'none';
      }, 100);
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <GAListener />
      <div className="App index-page">
        <div id="preloader"></div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/principals-welcome" element={<PrincipalsWelcome />} />
          <Route path="/international-student" element={<InternationalStudent />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/course-fees" element={<CourseFees />} />
          <Route path="/edsq" element={<EDSQ />} />
          <Route path="/bcs-itq" element={<BCSITQ />} />
          <Route path="/maths-functional-entry" element={<MathsFunctionalEntry />} />
          <Route path="/english-functional-entry" element={<EnglishFunctionalEntry />} />
          <Route path="/functional-english-level-2" element={<FunctionalEnglishLevel2 />} />
          <Route path="/functional-maths-level-2" element={<FunctionalMathsLevel2 />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/apprenticeships-intro" element={<ApprenticeshipsIntro />} />
          <Route path="/info-manager-level-4" element={<InfoManagerLevel4 />} />
          <Route path="/adult-care-worker-level-2" element={<AdultCareWorkerLevel2 />} />
          <Route path="/hair-professional-level-2" element={<HairProfessionalLevel2 />} />
          <Route path="/creative-hair-professional-level-3" element={<CreativeHairProfessionalLevel3 />} />
          <Route path="/lead-adult-care-worker-level-3" element={<LeadAdultCareWorkerLevel3 />} />
          <Route path="/leader-adult-care-level-5" element={<LeaderAdultCareLevel5 />} />
          <Route path="/lead-practitioner-adult-care-level-4" element={<LeadPractitionerAdultCareLevel4 />} />
          <Route path="/commis-chef-level-2" element={<CommisChefLevel2 />} />
          <Route path="/production-chef-level-2" element={<ProductionChefLevel2 />} />
          <Route path="/business-administration-level-3" element={<BusinessAdministrationLevel3 />} />
          <Route path="/ukeu-students" element={<UKEUStudents />} />
          <Route path="/data-protection" element={<DataProtectionPolicy />} />
          <Route path="/complaint" element={<ComplaintPolicy />} />
          <Route path="/equality-diversity" element={<EqualityDiversityPolicy />} />
          <Route path="/assessment-appeals" element={<AssessmentAppealsPolicy />} />
          <Route path="/health-safety" element={<HealthSafetyPolicy />} />
          <Route path="/conflict-interest" element={<ConflictInterestPolicy />} />
          <Route path="/college-iag" element={<CollegeIAGPolicy />} />
          <Route path="/malpractice-plagiarism" element={<MalpracticePlagiarismPolicy />} />
          <Route path="/safer-recruitment" element={<SaferRecruitmentPolicy />} />
          <Route path="/sustainability" element={<SustainabilityPolicy />} />
          <Route path="/modern-slavery" element={<ModernSlaveryPolicy />} />
          <Route path="/safeguarding" element={<SafeguardingPolicy />} />
          <Route path="/prevent" element={<PreventPolicy />} />
          <Route path="/whistleblowing" element={<WhistleblowingPolicy />} />
        </Routes>
        <ScrollTop />
      </div>
    </Router>
  );
}

export default App;
